import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../supabase";

function AdoptTV() {
  const { deviceId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tvName, setTvName] = useState("");
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    const { data, error } = await supabase
      .from("tv_groups")
      .select("*")
      .order("name");

    if (error) {
      console.error("Error fetching groups:", error);
      return;
    }

    setGroups(data);
  };

  const handleAdopt = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);

      // Check if device already exists
      const { data: existingDevice } = await supabase
        .from("tv_devices")
        .select("*")
        .eq("device_id", deviceId)
        .single();

      if (existingDevice) {
        setError("This TV has already been adopted");
        return;
      }

      // Get current user
      const {
        data: { user },
        error: userError,
      } = await supabase.auth.getUser();
      if (userError) throw userError;

      console.log("Current user:", user);

      // Ensure profile exists
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single();

      if (profileError || !profile) {
        // Create profile if it doesn't exist
        const { error: insertProfileError } = await supabase
          .from('profiles')
          .insert({ id: user.id, email: user.email });
        
        if (insertProfileError) throw insertProfileError;
      }

      // Insert new device
      const { data: insertedDevice, error: insertError } = await supabase
        .from("tv_devices")
        .insert({
          device_id: deviceId,
          name: tvName,
          group_id: selectedGroup || null,
          created_by: user.id,
          is_active: true,
        })
        .select("*")
        .single();

      console.log("Insert attempt:", { deviceId, tvName, userId: user.id });

      if (insertError) {
        console.error("Insert error:", insertError);
        throw insertError;
      }

      console.log("Inserted device:", insertedDevice);

      // Only navigate after successful insertion
      if (insertedDevice) {
        // navigate('/');
      } else {
        throw new Error("Failed to create device");
      }
    } catch (error) {
      console.error("Adoption error:", error);
      setError(error.message || "Failed to adopt TV. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900">
            Adopt TV Device
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Device ID: {deviceId}
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleAdopt}>
          {error && (
            <div className="bg-red-50 p-4 rounded text-red-600 text-sm">
              {error}
            </div>
          )}
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <input
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="TV Name"
                value={tvName}
                onChange={(e) => setTvName(e.target.value)}
              />
            </div>
            <div>
              <select
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
              >
                <option value="">No Group</option>
                {groups.map((group) => (
                  <option key={group.id} value={group.id}>
                    {group.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {loading ? "Adopting..." : "Adopt TV"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdoptTV;
